import { Button, Checkbox, Dialog, FormGroup, IDialogProps, Intent } from '@blueprintjs/core'
import React from 'react'
import Select from 'react-select'
import Client from '../../../client'
import APIErrorCallout from '../../../components/errors/APIErrorCallout'
import Channels from '../../../constants/Channels'
import PurgeReasons from '../../../constants/shopgoodwill/PurgeReasons'
import { getFromStorage, setInStorage } from '../../../storage'
import { showToast } from '../../../Toast'
import { mapToLabelValueList, S } from '../../../utils'

const LISTING_OPTION_RECYCLE_PRODUCT = 'LISTING_OPTION_RECYCLE_PRODUCT_KEY'

export interface Props extends IDialogProps {
  onClose: any
  data: any
  listingPaymentDeadline: string | null
}

interface State {
  loading: boolean
  error: Error
  alsoRecycleProduct: boolean
  purgeReason: string
  dropPayResponsible: boolean
}

class PurgeDialog extends React.Component<Props, State> {
  constructor(props) {
    super(props)

    // attempt to check the checkbox according to the rules that SGW implements today. Before the payment deadline has passed, it's checked by default, otherwise unchecked by default.
    let dropPayResponsible = false
    if (props.listingPaymentDeadline && new Date(props.listingPaymentDeadline) > new Date()) {
      dropPayResponsible = true
    }

    this.state = {
      loading: false,
      error: null,
      alsoRecycleProduct: !!getFromStorage(LISTING_OPTION_RECYCLE_PRODUCT, true),
      purgeReason: PurgeReasons.CLEAN.id,
      dropPayResponsible
    }
  }

  purge = async () => {
    const { data } = this.props
    const { alsoRecycleProduct, purgeReason, dropPayResponsible } = this.state
    this.setState({ loading: true, error: null })
    try {
      const res = await Client.v5ListingsRecycle(
        data,
        Channels.SHOPGOODWILL.id,
        alsoRecycleProduct,
        purgeReason,
        dropPayResponsible
      )
      this.setState({ loading: false }, () => {
        showToast(`Recycling ${data.length} listing${S(data)}...`, Intent.PRIMARY)
        this.props.onClose(true, res.data.failedIds)
      })
    } catch (error) {
      this.setState({
        loading: false,
        error: error.response
      })
    }
  }

  onClose = () => {
    this.setState(
      {
        loading: false,
        error: null
      },
      this.props.onClose
    )
  }

  onChangePurgeReason = e => {
    const val = e || PurgeReasons.CLEAN.id
    this.setState({ purgeReason: val || null })
  }

  setAlsoRecycleProduct = () => {
    this.setState(
      s => ({ alsoRecycleProduct: !s.alsoRecycleProduct }),
      () => setInStorage(LISTING_OPTION_RECYCLE_PRODUCT, this.state.alsoRecycleProduct, true)
    )
  }

  setDropPayResponsible = () => {
    this.setState(s => ({ dropPayResponsible: !s.dropPayResponsible }))
  }

  render() {
    const { isOpen, data } = this.props
    const { loading, error, alsoRecycleProduct, purgeReason, dropPayResponsible } = this.state
    return (
      <Dialog isOpen={isOpen} onClose={this.onClose} title="Recycle">
        {error && <APIErrorCallout response={error} />}
        <div className="bp3-dialog-body">
          These listing{S(data)} will move into the recycled tab and recycle on Shopgoodwill.com. Optionally use the
          checkbox below to prepare the product to be purged.
          <p>
            <h4>Options</h4>

            <FormGroup label="Recycle reason">
              <Select
                value={purgeReason}
                onChange={this.onChangePurgeReason}
                options={mapToLabelValueList(PurgeReasons)}
                clearable={false}
                simpleValue
              />
            </FormGroup>

            <Checkbox checked={alsoRecycleProduct} onClick={this.setAlsoRecycleProduct}>
              Also recycle product (disables ability to relist)
            </Checkbox>

            <Checkbox checked={dropPayResponsible} onClick={this.setDropPayResponsible}>
              Relieve payment responsibility
            </Checkbox>
          </p>
        </div>

        <div className="bp3-dialog-footer">
          <div className="bp3-dialog-footer-actions">
            <Button loading={loading} intent={Intent.PRIMARY} onClick={this.purge}>
              Recycle {data.length} listing{S(data)}
            </Button>
          </div>
        </div>
      </Dialog>
    )
  }
}

export default PurgeDialog
